/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PackageSubscriber from './package-subscriber';
import PackageSubscriberDetail from './package-subscriber-detail';
import PackageSubscriberUpdate from './package-subscriber-update';
import PackageSubscriberDeleteDialog from './package-subscriber-delete-dialog';

const PackageSubscriberRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PackageSubscriber />} />
    <Route path="new" element={<PackageSubscriberUpdate />} />
    <Route path=":id">
      <Route index element={<PackageSubscriberDetail />} />
      <Route path="edit" element={<PackageSubscriberUpdate />} />
      <Route path="delete" element={<PackageSubscriberDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PackageSubscriberRoutes;
